// Indicador com comparação nas quatro janelas e direção favorável explícita.
import {ReactNode} from 'react'
import Dica from './Dica'

type Direcao = 'up' | 'down'
type Fmt = (n: number | null | undefined) => string

interface Valores {
  hoje: number | null
  mtd: number | null
  m1: number | null
  ref: number | null
}

function Delta({
  atual,
  base,
  direcao,
  formato,
}: {
  atual: number | null
  base: number | null
  direcao: Direcao
  formato: Fmt
}) {
  if (atual === null || base === null) return null
  const d = atual - base
  if (Math.abs(d) < 1e-9)
    return (
      <div className='wd delta-neutral' title='Sem variação em relação a esta janela'>
        Estável
      </div>
    )
  const favoravel = direcao === 'up' ? d > 0 : d < 0
  return (
    <div
      className={`wd ${favoravel ? 'delta-good' : 'delta-bad'}`}
      title={`${favoravel ? 'Melhora' : 'Piora'} em relação a esta janela`}
    >
      <span aria-hidden='true'>{d > 0 ? '▲' : '▼'}</span> {formato(Math.abs(d))}
      <span className='sr-only'> · {favoravel ? 'melhora' : 'piora'}</span>
    </div>
  )
}

interface Props {
  label: string
  valores: Valores
  refLabel: string
  m1Label?: string
  formato: Fmt
  formatoDelta?: Fmt
  direcao?: Direcao
  extra?: string
  ajuda?: string
  icon?: ReactNode
}

export default function KpiCard({
  label,
  valores,
  refLabel,
  m1Label,
  formato,
  formatoDelta,
  direcao = 'up',
  extra,
  ajuda,
  icon,
}: Props) {
  const fd = formatoDelta || formato
  return (
    <article className='kpi' aria-label={label}>
      <div className='label flex items-start justify-between gap-2'>
        <span className='kpi-title'>
          {icon && (
            <span className='kpi-icon' aria-hidden='true'>
              {icon}
            </span>
          )}
          {label}
        </span>
        {ajuda && <Dica titulo={label} texto={ajuda} />}
      </div>
      <div className='value'>{formato(valores.mtd)}</div>
      <div className='janela-tag'>MÊS CORRENTE (MTD)</div>
      {extra && <div className='kpi-extra'>{extra}</div>}
      <div className='windows' aria-label='Comparação entre períodos'>
        <div className='w'>
          <div className='wl'>Hoje</div>
          <div className='wv'>{formato(valores.hoje)}</div>
        </div>
        <div className='w'>
          <div className='wl' title='Comparação justa: mês anterior até o mesmo dia'>
            {m1Label || 'M-1'}
          </div>
          <div className='wv'>{formato(valores.m1)}</div>
          <Delta atual={valores.mtd} base={valores.m1} direcao={direcao} formato={fd} />
        </div>
        <div className='w'>
          <div className='wl'>{refLabel}</div>
          <div className='wv'>{formato(valores.ref)}</div>
          <Delta atual={valores.mtd} base={valores.ref} direcao={direcao} formato={fd} />
        </div>
      </div>
    </article>
  )
}
